var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"modalidade","rota-base":"/admin/modalidade","titulo-singular":"Modalidade","campos-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24},{"campo":"ordem","label":"Ordem","tipo":"int"}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }